import { useMutation, useQuery } from '@apollo/react-hooks'
import gql from 'graphql-tag'
import moment from 'moment'
import { useContext, useRef, useState } from 'react'
import { Link } from 'react-router-dom'
import { Button, Card, Form, Icon, Image, Label, Loader } from 'semantic-ui-react'


import DeleteButton from '../components/DeleteButton'
import LikeButton from '../components/LikeButton'
import { AuthContext } from '../context/authContext'

import './SinglePost.css'

function SinglePost(props) {
    const postId = props.match.params.postId

    const { user } = useContext(AuthContext)
    const commentInputRef = useRef(null)

    const [comment, setComment] = useState('')

    const { data } = useQuery(FETCH_POST_QUERY, {
        variables: {
            postId
        },
        onError(err) {
            console.log(err.message)
            props.history.push('/NotFound')
        }
    })

    const [submitComment] = useMutation(SUBMIT_COMMENT_MUTATION, {
        update() {
            setComment('');
            commentInputRef.current.blur();
        },
        variables: {
            postId,
            body: comment
        },
        onError(err) {
            console.log(err.message)
        }
    })

    const deletePostCallback = () => {
        props.history.push('/')
    }

    let postMarkup;
    if(!data) {
        postMarkup = <Loader active />
    } else {
        const {
            id,
            body,
            createdAt,
            username,
            userId,
            comments,
            likes,
            likeCount,
            commentCount
        } = data.getPost

        postMarkup = (
            <>
                <div style={{display: 'flex'}}>
                    <Image
                        src='https://react.semantic-ui.com/images/avatar/large/molly.png'
                        float='right'
                        style={{height: '9vh', maxWidth: '100px', margin: '15px 10px 0px 0px'}}
                    />
                    <Card fluid style={{maxWidth: '750px'}} >
                        <Card.Content>
                            <Card.Header as={Link} to={`/user/${userId}`} >{username}</Card.Header>
                            <Card.Meta>{moment(createdAt).fromNow()}</Card.Meta>
                            <Card.Description style={{whiteSpace: "pre-line"}} >{body}</Card.Description>
                        </Card.Content>
                        <hr/>
                        <Card.Content extra>
                            <LikeButton user={user} post={{ id, likeCount, likes }} />
                            <Button
                                as='div'
                                labelPosition='right'
                                onClick={() => console.log('Comment on post')}
                            >
                                <Button basic color='blue' >
                                    <Icon name='comments'/>
                                </Button>
                                <Label basic color='blue' pointing='left'>
                                    {commentCount}
                                </Label>
                            </Button>
                            {user && user.username === username && (
                                <DeleteButton postId={id} callback={deletePostCallback}/>
                            )}
                        </Card.Content>
                    </Card>
                </div>
                {user && (
                    <Card fluid className='post-comment'>
                        <Card.Content>
                            <p>Post a comment</p>
                            <Form>
                                <div className='ui action input fluid'>
                                    <textarea
                                        rows="1"
                                        placeholder="Comment..."
                                        name='comment'
                                        value={comment}
                                        onChange={event => setComment(event.target.value)}
                                        ref={commentInputRef}
                                    />
                                    <button type='submit'
                                        className='ui button teal'
                                        disabled={comment.trim() === ''}
                                        onClick={submitComment}
                                    >
                                        Submit
                                    </button>
                                </div>
                            </Form>
                        </Card.Content>
                    </Card>
                    
                )}
                {comments.map(comment => (
                    <Card className='post-comment' fluid key={comment.id}>
                        <Card.Content>
                            {user && user.username === comment.username && (
                                <DeleteButton postId={id} commentId={comment.id}/>
                            )}
                            <Card.Header>{comment.username}</Card.Header>
                            <Card.Meta>{moment(comment.createdAt).fromNow()}</Card.Meta>
                            <Card.Description>{comment.body}</Card.Description>
                        </Card.Content>
                    </Card>
                ))}
            </>
        )
    }

    return postMarkup
}

const FETCH_POST_QUERY = gql`
    query ($postId: ID!) {
        getPost (postId: $postId) {
            id
            body
            createdAt
            username
            likes {
                id
                username
                createdAt
            }
            likeCount
            comments {
                id
                body
                username
                createdAt
            }
            commentCount
            userId
        }
    }
`
const SUBMIT_COMMENT_MUTATION = gql`
    mutation createComment($postId: ID!, $body: String!) {
        createComment (postId: $postId, body: $body) {
            id
            comments {
                id
                body
                createdAt
                username
            }
            commentCount
        }
    }
`

export default SinglePost
